module.exports = __webpack_public_path__ + "static/media/navidad_2024.88dc2bcc.png";